import Logo from '../../assets/signIn_logo.svg'
import './signIn.css'
import { Button, Space, Typography } from 'antd'
import { CustomInput } from '../../components'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { signInSchema } from '../../Validations/signInValid'
import { LOG_IN_QUERY } from '../../Graphql/queries/getQueries'
import { useLazyQuery } from '@apollo/client'
import { useNavigate } from 'react-router-dom'
import { useMiddlewareContext } from '../../middleware'

const SignIn = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(signInSchema),
    });

    const [signInValues, setSignInValues] = useState({ email: '', password: '' })
    const [authError, setAuthError] = useState('')
    const [login, { loading }] = useLazyQuery(LOG_IN_QUERY);
    const { setToken, setRefreshToken } = useMiddlewareContext();

    const onChange = (e) => {
        const { value, name } = e.target
        setSignInValues(prev => ({ ...prev, [name]: value }))
    }

    const onSubmit = (formValues) => {

        login({ variables: { email: formValues.email, password: formValues.password } })
            .then(res => {

                if (res.error) setAuthError("Your email or password is incorrect")
                if (res.data) {
                    const { authToken, refreshToken } = res.data.login
                    localStorage.setItem('refreshToken', JSON.stringify(refreshToken));
                    localStorage.setItem('token', authToken)
                    setToken(authToken);
                    setRefreshToken(refreshToken);
                    setAuthError('')
                    navigate('/')
                }
            })
    }
    return (
        <form className='flex_center sign_in_wrapper' onSubmit={handleSubmit(onSubmit)} >
            <div className="sign_in_form flex_center_ver">
                <img src={Logo} alt="Logo" />
                <Space direction='vertical' size={20} style={{ width: '100%' }}>
                    <CustomInput value={signInValues.email}
                        register={register}
                        onChange={onChange}
                        required
                        error={errors}
                        name='email'
                        type='text'
                        label='Email'
                        borderColor='transparent'
                        width='100%' />
                    <CustomInput value={signInValues.password}
                        register={register}
                        onChange={onChange}
                        required name='password'
                        error={errors}
                        type='password'
                        label='Password'
                        borderColor='transparent'
                        width='100%' />
                    {authError && <Typography.Paragraph style={{ color: 'red', fontWeight: 500 }} >{authError} </Typography.Paragraph>}
                    <Button block type='primary' htmlType="submit" loading={loading}>Login</Button>
                </Space>

            </div>

        </form>
    )
}

export default SignIn